import { InfoCircleOutlined } from "@ant-design/icons"
import { Flex, Tooltip } from "antd"

import Icon from "../Icon"

export const titleSortFilters = ({
  title,
  sorter,
  icon,
  stateData,
  key,
  tooltip,
  justify,
  dataTour
}) => {
  let sortIcon = "sort"
  let sortedColumn = null
  if (Array.isArray(stateData?.sortColumns)) {
    sortedColumn = stateData.sortColumns?.find(({ column }) => column.dataIndex === key)
  } else {
    sortedColumn = stateData.sortColumn
  }

  if (sortedColumn?.column?.dataIndex === key) {
    if (sortedColumn?.order === "descend") {
      sortIcon = "sort_descend"
    } else if (sortedColumn?.order === "ascend") {
      sortIcon = "sort_ascend"
    }
  }

  return (
    <Flex
      gap={4}
      align="center"
      className="table-column-title"
      justify={justify || "start"}
      data-tour={dataTour}
    >
      {icon && <Icon type={icon} style={{ fontSize: 16, lineHeight: 1 }} />}
      <span className="table-column-title-text">{title}</span>
      {tooltip && (
        <Tooltip placement="bottom" title={tooltip}>
          <span>
            <InfoCircleOutlined />
          </span>
        </Tooltip>
      )}
      {sorter && <Icon type={sortIcon} style={{ fontSize: 16, lineHeight: 1 }} />}
    </Flex>
  )
}
